import { render, staticRenderFns } from "./PassengerPageRoot.vue?vue&type=template&id=588833de"
import script from "./PassengerPageRoot.vue?vue&type=script&lang=ts"
export * from "./PassengerPageRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports